module.exports = __webpack_public_path__ + "static/media/7.e13e6d41.svg";